import React from 'react';

import { IRouter } from '@routers/interface';

export const routerPagePagePaymentSuccess: IRouter = {
  path: '/pagePaymentSuccess',
  masterLayout: false,
  loader: React.lazy(() => import('./index')),
};
